import { googleAnalytics4Event, googleAnalytics4Impression } from './redux/actions';

require('./redux/beaconMiddleware');

export { googleAnalytics4Event, googleAnalytics4Impression };
